import { render, staticRenderFns } from "./GCheckboxWorkForm.vue?vue&type=template&id=e0756636&"
import script from "./GCheckboxWorkForm.vue?vue&type=script&lang=ts&"
export * from "./GCheckboxWorkForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports